export const PLUS = 'PLUS';
export const MINUS = 'MINUS';

export const SINGLEPRODUCT = 'SINGLEPRODUCT';
